var map = {
	"./home-box1-bg-light.png": "c02b",
	"./home-box1-bg.png": "8aa0",
	"./home-box1-sandbox-light.png": "21ef",
	"./home-box1-sandbox.png": "be7b",
	"./home-box4-bg.png": "e996",
	"./home-customer-choice-en.png": "d563",
	"./home-customer-choice-light-en.png": "c4db",
	"./home-customer-choice-light.png": "f7b8",
	"./home-customer-choice.png": "c48b",
	"./home-huawei-light.png": "d8d6",
	"./home-huawei.png": "7f67",
	"./home-meituan-light.png": "9789",
	"./home-meituan.png": "e709",
	"./home-midea-light.png": "0891",
	"./home-midea.png": "45733",
	"./home-prc-light.png": "95f9",
	"./home-prc.png": "d75e",
	"./home-product-advantage-en.png": "4454",
	"./home-product-advantage-light-en.png": "a67e",
	"./home-product-advantage-light.png": "20bb",
	"./home-product-advantage.png": "8167",
	"./home-scdx-light.png": "59eb",
	"./home-scdx.png": "fe78",
	"./home-selected-report-en.png": "3e8f",
	"./home-selected-report-light-en.png": "a866",
	"./home-selected-report-light.png": "9ea4",
	"./home-selected-report.png": "160e",
	"./home-service-price-en.png": "d431",
	"./home-service-price-light-en.png": "df9b",
	"./home-service-price-light.png": "c46c",
	"./home-service-price.png": "8ace",
	"./home-servicePrice-mf-light.png": "fe02",
	"./home-servicePrice-mf.png": "bdf1",
	"./home-servicePrice-qy-light.png": "71a7",
	"./home-servicePrice-qy.png": "2c5a",
	"./home-servicePrice-zy-light.png": "4ab5",
	"./home-servicePrice-zy.png": "0285",
	"./home-servicePrice-zyzq-light.png": "e419",
	"./home-servicePrice-zyzq.png": "f895",
	"./home-swiper-1.png": "4988",
	"./home-swiper-2.png": "721d",
	"./home-swiper-3.png": "be6e",
	"./home-swiper-4.png": "d36a",
	"./home-swiper-5.png": "af65",
	"./home-swiper-dot-active.png": "f88f",
	"./home-swiper-dot.png": "b0bb",
	"./home-tab-active.png": "477f",
	"./home-time-logo.png": "a8a3",
	"./home-typical-scenarios-en.png": "341e",
	"./home-typical-scenarios-icon1.png": "2024",
	"./home-typical-scenarios-icon2.png": "5a61",
	"./home-typical-scenarios-icon3.png": "2aa7",
	"./home-typical-scenarios-light-en.png": "e2b6",
	"./home-typical-scenarios-light.png": "a6a8",
	"./home-typical-scenarios.png": "77d5",
	"./home-window-logo.png": "f3d3",
	"./home-wz-light.png": "bd47",
	"./home-wz.png": "e080",
	"./home-yjzx-light.png": "1452",
	"./home-yjzx.png": "8556",
	"./home-zggs-light.png": "1c6d",
	"./home-zggs.png": "266a",
	"./home-zgyd-light.png": "dfdc",
	"./home-zgyd.png": "f488",
	"./home-zhaoshang-light.png": "2065",
	"./home-zhaoshang.png": "9752"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0792";